import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Copy .env.local.template to .env.local and fill in your values.'
  )
}

// ─────────────────────────────────────────────────────────────────────────────
// Supabase client configuration
// ─────────────────────────────────────────────────────────────────────────────
// Notes on each setting:
//
//   flowType: 'pkce'
//     Use the PKCE flow rather than the legacy implicit flow. PKCE does the
//     code-for-token exchange in a single round-trip and is the supabase-js
//     v2 recommended default. The old implicit flow is the cause of most
//     "auth feels slow" reports — it can take an extra hop on token refresh.
//
//   storageKey: 'techbench-auth'
//     Explicit storage key avoids collisions with any other Supabase project
//     you've ever opened in the same browser profile. Without this, the
//     default key 'sb-<projectref>-auth-token' can clash when projects share
//     a domain (we don't, but it's cheap insurance) and makes the storage
//     entry identifiable when you're debugging from devtools.
//
//   persistSession / autoRefreshToken / detectSessionInUrl
//     Standard. Keep the session across reloads, refresh tokens in the
//     background, and read the recovery token out of the URL hash on
//     /reset-password without us having to parse it manually.
// ─────────────────────────────────────────────────────────────────────────────

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType:            'pkce',
    storageKey:          'techbench-auth',
    storage:             window.localStorage,
    persistSession:      true,
    autoRefreshToken:    true,
    detectSessionInUrl:  true,
  },
})
